import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { SprayEventEntityId } from 'services/sprayEvents/types';
import { makeSelectSprayInnerEntityOptions } from './selectors';
import { InnerEntityOptions } from './types';
import { EntityDropdownOptions } from '../../types';

type ChildrenFunction = (values: any) => React.ReactElement;

export interface OwnProps {
    options: EntityDropdownOptions;
    children: React.ReactElement | ChildrenFunction;
    sprayEntityId?: SprayEventEntityId;
}

interface ConnectedProps {
    innerEntityOptions: InnerEntityOptions;
}

type Props = OwnProps & ConnectedProps;

export class SpraySchemaInnerEntityOptionsComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { innerEntityOptions, children } = this.props;

        if (typeof children === 'function') {
            return children(innerEntityOptions);
        }

        // @ts-ignore
        return React.cloneElement(children, { innerEntityOptions });
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    innerEntityOptions: makeSelectSprayInnerEntityOptions()
});

export default connect(mapStateToProps)(SpraySchemaInnerEntityOptionsComponent);
